import React from "react";
import FormikInput from "../../../../Components/Formik/FormikInput";
import FormikSelect from "../../../../Components/Formik/FormikSelect";
import { useFormikContext } from "formik";
import { useLanguage } from "../../../../Components/LangTranslation/LanguageContext";
import { Tooltip as ReactTooltip } from "react-tooltip";
import { checkApi } from "../../../../DataApi/onboarding/checkApi";

function VtexCreateWebsiteStep({
  countriesOption,
  governateOption,
  governateBOption,
  wilayatOption,
  wilayatBOption,
  cityOption,
  cityBOption,
  areaOption,
  areaBOption,
  onChangeCountry,
  onChangeGovernate,
  onChangeWilayat,
  onChangeCity,
  // onChangeArea,
  isPickupAddress,
  setIsPickupAddress,
}) {
  const { setFieldValue } = useFormikContext();
  const { language, translations } = useLanguage();
  const t = translations[language];
  const defaultCountryOption = { label: "Oman", value: 171, phone_code: 968 };

  const optionsWithDisabled = countriesOption.map((option) => ({
    ...option,
    isDisabled: option.value !== defaultCountryOption.value,
  }));
  const toggleSwitch = () => {
    setIsPickupAddress(!isPickupAddress);
  };
  return (
    <>
      <div
        className="col-12 row me-0 pe-0"
        style={{
          border: "1px dashed rgb(203, 203, 203)",
          borderRadius: "15px",
        }}
      >
        <div className="col-12 mt-3">
          <h6 className="text-center text-secondary fw-bold">
            {t["Billing | Headquaters (HQ) Address"]}
          </h6>
        </div>
        <div className="my-3 col-md-4 col-12">
          <FormikSelect
            name="country"
            onChange={(option) => {
              onChangeCountry(option.value);
              setFieldValue("phone_prefix", option.phone_code || "");
              // setFieldValue("phone", option.phone || "");
            }}
            options={optionsWithDisabled}
            placeholder={t["Country"] + "*"}
            data-tooltip-id="countryTooltip"
            data-tooltip-content={t["Country"] + "*"}
          />
          <ReactTooltip id="countryTooltip" type="dark" effect="solid" />
        </div>
        <div className="my-3 col-md-4 col-12">
          <FormikSelect
            name="governate"
            onChange={(option) => {
              onChangeGovernate(option.value, "governate");
              // setFieldValue("zip", option.zip || "");
            }}
            options={governateOption}
            placeholder={t["Governorate"] + "*"}
            data-tooltip-id="governateTooltip"
            data-tooltip-content={t["Governorate"] + "*"}
          />
          <ReactTooltip id="governateTooltip" type="dark" effect="solid" />
        </div>
        <div className="my-3 col-md-4 col-12">
          <FormikSelect
            name="wilayat"
            onChange={(option) => {
              onChangeWilayat(option.value, "wilayat");
              // setFieldValue("zipB", option.zip || "");
            }}
            options={wilayatOption}
            placeholder={t["Wilayat"] + "*"}
            data-tooltip-id="wilayatTooltip"
            data-tooltip-content={t["Wilayat"] + "*"}
          />
          <ReactTooltip id="wilayatTooltip" type="dark" effect="solid" />
        </div>
        <div className="my-3 col-md-4 col-12">
          <FormikSelect
            name="city"
            onChange={(option) => {
              onChangeCity(option.value, "city");
              // setFieldValue("zipB", option.zip || "");
            }}
            options={cityOption}
            placeholder={t["City"] + "*"}
            data-tooltip-id="cityTooltip"
            data-tooltip-content={t["City"] + "*"}
          />
          <ReactTooltip id="cityTooltip" type="dark" effect="solid" />
        </div>
        <div className="my-3 col-md-4 col-12">
          <FormikSelect
            name="area"
            onChange={(option) => {
              checkApi({
                endpoint: "/onboarding/zip",
                params: {
                  area_id: option.value,
                },
              }).then((zip) => {
                if (zip?.result?.result?.length > 0) {
                  const zipOp = zip?.result?.result?.map((item) => ({
                    label: item.name,
                    value: item.id,
                  }));
                  // console.log("zipOp", zipOp);
                  setFieldValue("zip", zipOp?.[0].label || "");
                }
              });
            }}
            options={areaOption}
            placeholder={t["Area"] + "*"}
            data-tooltip-id="areaTooltip"
            data-tooltip-content={t["Area"] + "*"}
          />
          <ReactTooltip id="areaTooltip" type="dark" effect="solid" />
        </div>
        {/* <div className="my-3 col-md-4 col-12">
          <FormikInput
            name="city"
            placeholder={t["City"]}
            data-tooltip-id="cityTooltip"
            data-tooltip-content={t["City"] + "*"}
          />
          <ReactTooltip id="cityTooltip" type="dark" effect="solid" />
        </div> */}
        <div className="my-3 col-md-4 col-12">
          <FormikInput
            name="street"
            placeholder={t["Street"] + "*"}
            data-tooltip-id="streetTooltip"
            data-tooltip-content={t["Street"] + "*"}
          />
          <ReactTooltip id="streetTooltip" type="dark" effect="solid" />
        </div>
        <div className="my-3 col-md-6 col-12">
          <FormikInput
            disabled={true}
            name="zip"
            placeholder={t["Zip Code"] + "*"}
            data-tooltip-id="zipTooltip"
            data-tooltip-content={t["Zip Code"] + "*"}
          />
          <ReactTooltip id="zipTooltip" type="dark" effect="solid" />
        </div>
        <div className="my-3 col-md-6 col-12 d-flex">
          <FormikInput name="phone_prefix" readOnly />
          <div className="d-flex flex-column w-100">
            <FormikInput
              name="phone"
              type="number"
              placeholder={t["Phone Number"] + "*"}
              data-tooltip-id="phoneTooltip"
              data-tooltip-content={t["Phone Number"] + "*"}
            />
            <ReactTooltip id="phoneTooltip" type="dark" effect="solid" />
          </div>
        </div>
      </div>
      <div className="form-check form-switch my-3" style={{ width: "60%" }}>
        <label
          className="form-check-label text-secondary fw-bold"
          htmlFor="isSecondaryContact"
        >
          {
            t[
              "Is the pickup address different from the billing | headquarters (HQ) address?"
            ]
          }
        </label>
        <input
          className="form-check-input mt-1"
          type="checkbox"
          checked={isPickupAddress}
          id="isPickupAddress"
          data-tooltip-id="isBillingAddressTooltip"
          data-tooltip-content="Toggle to add the billing address separately!"
          onChange={toggleSwitch}
        />
        <ReactTooltip id="isBillingAddressTooltip" type="dark" effect="solid" />
      </div>
      {isPickupAddress && (
        <div
          className="col-12 row me-0 pe-0"
          style={{
            border: "1px dashed rgb(203, 203, 203)",
            borderRadius: "15px",
          }}
        >
          <div className="col-12 mt-3">
            <h6 className="text-center text-secondary fw-bold">
              {t["Pickup Address"]}
            </h6>
          </div>
          <div className="my-3 col-md-4 col-12">
            <FormikSelect
              name="countryB"
              onChange={(option) => {
                onChangeCountry(option.value);
                setFieldValue("phone_prefixB", option.phone_code || "");
                // setFieldValue("phone", option.phone || "");
              }}
              options={optionsWithDisabled}
              placeholder={t["Country"] + "*"}
              data-tooltip-id="countryTooltip"
              data-tooltip-content={t["Country"] + "*"}
            />
            <ReactTooltip id="countryTooltip" type="dark" effect="solid" />
          </div>
          <div className="my-3 col-md-4 col-12">
            <FormikSelect
              name="governateB"
              onChange={(option) => {
                onChangeGovernate(option.value, "governateB");
              }}
              options={governateOption}
              placeholder={t["Governorate"] + "*"}
              data-tooltip-id="governateBTooltip"
              data-tooltip-content={t["Governorate"] + "*"}
            />
            <ReactTooltip id="governateBTooltip" type="dark" effect="solid" />
          </div>
          <div className="my-3 col-md-4 col-12">
            <FormikSelect
              name="wilayatB"
              onChange={(option) => {
                onChangeWilayat(option.value, "wilayatB");
              }}
              options={wilayatBOption}
              placeholder={t["Wilayat"] + "*"}
              data-tooltip-id="wilayatBTooltip"
              data-tooltip-content={t["Wilayat"] + "*"}
            />
            <ReactTooltip id="wilayatBTooltip" type="dark" effect="solid" />
          </div>
          <div className="my-3 col-md-4 col-12">
            <FormikSelect
              name="cityB"
              onChange={(option) => {
                onChangeCity(option.value, "cityB");
                // setFieldValue("zipB", option.zip || "");
              }}
              options={cityBOption}
              placeholder={t["City"] + "*"}
              data-tooltip-id="cityBTooltip"
              data-tooltip-content={t["City"] + "*"}
            />
            <ReactTooltip id="cityBTooltip" type="dark" effect="solid" />
          </div>
          <div className="my-3 col-md-4 col-12">
            <FormikSelect
              name="areaB"
              onChange={(option) => {
                checkApi({
                  endpoint: "/onboarding/zip",
                  params: {
                    area_id: option.value,
                  },
                }).then((zip) => {
                  if (zip?.result?.result?.length > 0) {
                    const zipBOp = zip?.result?.result?.map((item) => ({
                      label: item.name,
                      value: item.id,
                    }));
                    setFieldValue("zipB", zipBOp?.[0].label || "");
                  }
                });
              }}
              options={areaBOption}
              placeholder={t["Area"] + "*"}
              data-tooltip-id="areaBTooltip"
              data-tooltip-content={t["Area"] + "*"}
            />
            <ReactTooltip id="areaBTooltip" type="dark" effect="solid" />
          </div>
          <div className="my-3 col-md-4 col-12">
            <FormikInput
              name="streetB"
              placeholder={t["Street"] + "*"}
              data-tooltip-id="streetTooltip"
              data-tooltip-content={t["Street"] + "*"}
            />
            <ReactTooltip id="streetTooltip" type="dark" effect="solid" />
          </div>
          <div className="my-3 col-md-6 col-12">
            <FormikInput
              disabled={true}
              name="zipB"
              placeholder={t["Zip Code"] + "*"}
              data-tooltip-id="zipTooltip"
              data-tooltip-content={t["Zip Code"] + "*"}
            />
            <ReactTooltip id="zipTooltip" type="dark" effect="solid" />
          </div>
          <div className="my-3 col-md-6 col-12 d-flex">
            <FormikInput name="phone_prefixB" readOnly />
            <div className="d-flex flex-column w-100">
              <FormikInput
                name="phoneB"
                type="number"
                placeholder={t["Phone Number"] + "*"}
                data-tooltip-id="phoneTooltip"
                data-tooltip-content={t["Phone Number"] + "*"}
              />
              <ReactTooltip id="phoneTooltip" type="dark" effect="solid" />
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default VtexCreateWebsiteStep;
